import { useState } from 'react';
import SafeguardMap from './Map';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import ManageOrganizations from '../../SafeguardViews/manage_organizations/ManageOrganizations';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import { useUserUpdaterProvider } from '../../../context_providers/user_context/UserUpdaterProvider';
import Loading from '../../../components/loading/Loading';
import { useAppVersionProvider } from '../../../context_providers/app_version_context/AppVersionProvider';
import UpdateRequiredModal from './update_required/UpdateRequiredModal';
import { useBannerHeight } from '../../../context_providers/banner_context/BannerHeightContext';
import { styled } from '@mui/material/styles';
import ProductionFeatureNotification from '../../../components/notifications/ProductionFeatureNotification';

// Create a styled container component
const MapContainer = styled('div')(({ _, bannerHeight }) => {
  const navbarHeight = 65; // Navbar height is consistent at 65px

  return {
    width: '100%', // Use 100% instead of 100dvw to avoid scrollbar issues
    // Subtract 1px to account for potential rounding issues in browsers
    height: `calc(100dvh - ${navbarHeight}px - ${bannerHeight}px - 1px)`,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden', // Prevent any content from overflowing
    maxWidth: '100%', // Ensure container doesn't exceed viewport
    margin: 0,
    padding: 0,
  };
});

const Home = () => {
  const {
    isSafeguardAdmin,
    safeguardView,
    isSafeguardManufacturingUser,
    isSafeguardDev,
  } = useUserContext();
  const { userHistory, orgUser, userPrivateSettings } =
    useUserUpdaterProvider();
  const {
    inMaintenance,
    futureUpdateRequired,
    setUpdateAcknowledged,
    updateAcknowledged,
  } = useAppVersionProvider();
  const { emergencyBannerHeight, developmentBannerHeight } = useBannerHeight();
  const [showUpdateRequiredModal, setShowUpdateRequiredModal] = useState(false);

  // Calculate total banner height
  const totalBannerHeight = emergencyBannerHeight + developmentBannerHeight;

  if (inMaintenance && !safeguardView) return null;
  if (
    futureUpdateRequired &&
    !showUpdateRequiredModal &&
    !updateAcknowledged &&
    !inMaintenance
  )
    setShowUpdateRequiredModal(true);
  if ((isSafeguardAdmin || isSafeguardDev) && safeguardView) {
    return (
      <>
        <ManageOrganizations />
      </>
    );
  } else if (
    (isSafeguardAdmin || isSafeguardManufacturingUser) &&
    !safeguardView
  ) {
    return (
      <>
        <MapContainer bannerHeight={totalBannerHeight}>
          <SafeguardMap />
          <UpdateRequiredModal
            show={showUpdateRequiredModal}
            onHide={() => {
              setShowUpdateRequiredModal(false);
              setUpdateAcknowledged(true);
            }}
          />
        </MapContainer>
        <ProductionFeatureNotification />
      </>
    );
  }

  if (!isSafeguardAdmin && orgUser && userHistory && userPrivateSettings) {
    return (
      <>
        <MapContainer bannerHeight={totalBannerHeight}>
          <SafeguardMap />
          <UpdateRequiredModal
            show={showUpdateRequiredModal}
            onHide={() => {
              setShowUpdateRequiredModal(false);
              setUpdateAcknowledged(true);
            }}
          />
        </MapContainer>
        <ProductionFeatureNotification />
      </>
    );
  }
};

const HomeWithAuth = withAuthenticationRequired(Home, {
  onRedirecting: () => <Loading loadingText={'Loading...'} />,
});
HomeWithAuth.displayName = 'HomeWithAuth';
export default HomeWithAuth;
